import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export function BlogList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/blog").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
        <p className="text-xs tracking-[0.3em] uppercase text-[#C24D2C]">Blog & News</p>
        <h1 className="mt-4 font-serif-display text-5xl lg:text-6xl text-[#1A2456] font-bold">
          Notes from the desk.
        </h1>

        {loading ? (
          <p className="mt-14 text-[#8A817C]">Loading…</p>
        ) : items.length === 0 ? (
          <p className="mt-14 text-[#8A817C] italic">No posts yet.</p>
        ) : (
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((b) => (
              <Link
                key={b.id}
                to={`/blog/${b.id}`}
                data-testid={`blog-item-${b.id}`}
                className="card-lift bg-white border border-[#D8CFC4] block"
              >
                {b.image_url && (
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={b.image_url} alt={b.title} className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-6">
                  <p className="text-[10px] tracking-[0.25em] uppercase text-[#8A817C]">
                    {new Date(b.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
                  </p>
                  <h2 className="mt-2 font-serif-display text-xl text-[#1A2456]">{b.title}</h2>
                  {b.excerpt && <p className="mt-3 text-sm text-[#5C544F] line-clamp-3">{b.excerpt}</p>}
                  <span className="mt-4 inline-block text-sm text-[#E35D29] link-underline">Read →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export function BlogDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get(`/blog/${id}`).then((r) => setPost(r.data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="max-w-3xl mx-auto p-20 text-[#8A817C]">Loading…</p>;
  if (!post) return <p className="max-w-3xl mx-auto p-20 text-[#8A817C]">Post not found.</p>;

  return (
    <article data-testid="blog-detail" className="max-w-3xl mx-auto px-6 sm:px-8 py-20">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[#C24D2C] link-underline">
        <ArrowLeft size={14} /> Back to blog
      </Link>
      <p className="mt-8 text-[10px] tracking-[0.3em] uppercase text-[#8A817C]">
        {new Date(post.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
      </p>
      <h1 className="mt-3 font-serif-display text-4xl lg:text-5xl text-[#1A2456] font-bold">{post.title}</h1>
      {post.image_url && (
        <img src={post.image_url} alt={post.title} className="mt-8 w-full aspect-[16/9] object-cover" />
      )}
      <div className="mt-10 text-lg text-[#2D2825] leading-relaxed whitespace-pre-wrap font-sans-body">
        {post.content}
      </div>
      <p className="mt-10 text-sm text-[#8A817C]">— {post.author}</p>
    </article>
  );
}
